import { ReactNode } from "react";
import "./useToastAlert.scss";
import SuccessIcon from "../../assets/icons/SuccessIcon";
import ErrorIcon from "../../assets/icons/ErrorIcon";
import toast from "react-hot-toast";
interface ToastSettings {
  subMessage?:
    | string
    | ((props: { onClose: () => void }) => ReactNode | JSX.Element);
  onClose?: () => void;
  message: string;
  duration?: number;
  position?: any;
  type?: "success" | "error";
}
export const useToastAlert = () => {
  const renderIcon = (type: ToastSettings["type"]) => {
    switch (type) {
      case "success":
        return <SuccessIcon className="icon-success" />;
      case "error":
        return <ErrorIcon className="icon-error" />;
      // case "warning":
      //   return <WarningIcon className="icon-warning" />;
    }
  };

  const toastAlert = ({
    duration = 4000,
    type = "success",
    message,
    subMessage,
    position = "bottom",
    onClose: onCloseProp,
  }: ToastSettings) => {
    toast[type](message);
  };
  return toastAlert;
};

//  <div className={`custom-toast-alert  custom-toast-alert-${type}`}>
//         <div className="right">
//           {renderIcon(type)}
//           <span className="text-medium-16">{message}</span>
//         </div>
//         <CloseIcon className="close__icon" onClick={onClose} />
//       </div>
